import { Box, Typography } from "@mui/material";
import StackedBarChartRoundedIcon from "@mui/icons-material/StackedBarChartRounded";
import { analyticsTheme } from "../theme";

interface AnalyticsEmptyBlockProps {
  label: string;
  height?: number;
}

export const AnalyticsEmptyBlock = ({
  label,
  height = 240,
}: AnalyticsEmptyBlockProps) => (
  <Box
    sx={{
      height,
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      gap: 1.5,
      textAlign: "center",
      px: 2,
    }}
  >
    <Box
      sx={{
        width: 52,
        height: 52,
        borderRadius: "50%",
        backgroundColor: analyticsTheme.pageBg,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: analyticsTheme.text.muted,
        "& svg": { fontSize: 26 },
      }}
    >
      <StackedBarChartRoundedIcon />
    </Box>
    <Typography
      sx={{
        fontSize: 14,
        fontWeight: 500,
        color: analyticsTheme.text.secondary,
      }}
    >
      {label}
    </Typography>
  </Box>
);
